<template>
<div class="pocket-wrap" :class="{ 'pocket-wrap-dark': skinModel == '1' }">
    <div v-if="changeDetail &amp;&amp; !tradeDetail" class="pocket-detail-wrap">
      <div class="pocket-amount">
        <span class="desc"><span v-if="changeDetail.accountType == 1">{{$t('入账')}}</span><span v-if="changeDetail.accountType == 2">{{$t('出账')}}</span>{{$t('金额')}}</span>
        <span class="amount">{{ changeDetail.amount | amount_convert }}</span>
      </div>
      <div class="pocket-desc">
        <div class="desc-item">
          <span class="label">{{$t('类       型')}}</span>
          <span class="desc">{{
            changeDetail.accountType | account_type
          }}</span>
        </div>
        <div class="desc-item">
          <span class="label">{{$t('时       间')}}</span>
          <span class="desc">{{ changeDetail.tradeTime }}</span>
        </div>
        <div class="desc-item">
          <span class="label">{{$t('交易单号')}}</span>
          <span class="desc">{{ changeDetail.tradeId }}</span>
        </div>
        <div class="desc-item">
          <span class="label">{{$t('剩余')}}<span v-if="changeDetail.ownerType == 1">{{$t('余额')}}</span><span v-if="changeDetail.ownerType == 0">{{$t('零钱')}}</span></span>
          <span class="desc">{{
            changeDetail.totalAmount | amount_convert
          }}</span>
        </div>
        <div class="desc-item">
          <span class="label">{{$t('备       注')}}</span>
          <span class="desc">{{ changeDetail.remark }}</span>
        </div>
      </div>
    </div>
    <div v-if="tradeDetail">
      <div class="trade-base-info-tixian">
        <img :src="tradeDetail.tradeObjectImage" class="trade-object-image">
        <p class="trade-ways">{{ tradeDetail.headTitle }}</p>
        <p class="trade-money">
          {{ tradeDetail.accountType == 2 ? '-' : '+' }}{{ tradeDetail.orderAmount | amount_convert }}
        </p>
      </div>
      <ul class="trade-detail-info">
        <li class="detail-item">
          <span class="detail-sub-title">{{$t('当前状态')}}</span>
          <span class="detail-sub-content">{{ tradeDetail.tradeStatusDesc }}</span>
        </li>
        <li class="detail-item">
          <span class="detail-sub-title">{{$t('提现金额')}}</span>
          <span class="detail-sub-content">￥{{ tradeDetail.orderAmount | amount_convert }}</span>
        </li>
        <li v-if="tradeDetail.serviceCharge" class="detail-item">
          <span class="detail-sub-title">{{$t('手续费')}}</span>
          <span class="detail-sub-content">￥{{ tradeDetail.serviceCharge | amount_convert }}</span>
        </li>
        <li v-if="tradeDetail.traderDesc" class="detail-item">
          <span class="detail-sub-title">{{ tradeDetail.traderDesc }}</span>
          <span class="detail-sub-content">{{ tradeDetail.trader }}</span>
        </li>
        <li v-if="tradeDetail.startTimeDesc" class="detail-item">
          <span class="detail-sub-title">{{ tradeDetail.startTimeDesc }}</span>
          <span class="detail-sub-content">{{ tradeDetail.startTime }}</span>
        </li>
        <li v-if="tradeDetail.endTimeDesc" class="detail-item">
          <span class="detail-sub-title">{{ tradeDetail.endTimeDesc }}</span>
          <span class="detail-sub-content">{{ tradeDetail.endTime }}</span>
        </li>
        <li v-if="tradeDetail.failReason" class="detail-item">
          <span class="detail-sub-title detail-sub-failreason">{{$t('退款原因')}}</span>
          <span class="detail-sub-content">{{ tradeDetail.failReason }}</span>
        </li>
        <li class="detail-item">
          <span class="detail-sub-title">{{$t('提现方式')}}</span>
          <span class="detail-sub-content">{{ tradeDetail.payTypeDesc }}</span>
        </li>
        <li class="detail-item">
          <span class="detail-sub-title">{{$t('交易单号')}}</span>
          <span class="detail-sub-content">{{ tradeDetail.tradeId }}</span>
        </li>
      </ul>
    </div>
    <div v-if="loading" class="spinner-wrap">
      <div class="snake-wrap">
        <mt-spinner type="triple-bounce"></mt-spinner>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { lang, transObj } from '@/utils/translate';
import http from '@/utils/http-interceptor';

const ACCOUNT_MAP = [transObj.$t('收入'), transObj.$t('支出')];

Vue.filter("account_type", function (val) {
  return ACCOUNT_MAP[val - 1];
});

Vue.filter("amount_convert", function (val) {
  return (val / 100).toFixed(2);
});

export default {
  data() {
    return {
      changeDetail: null,
      tradeDetail: null,
      loading: 0,
      ddtoken: "",
      userId: "",
      circleId: "",
      skinModel: "0",
      ownerType: "",
      ownerId: ""
    };
  },
  beforeRouteEnter(to, from, next) {
    let skinModel = to.query.skinModel;
    if (skinModel == "1") {
      document.documentElement.style.backgroundColor = "#191919";
      document.body.style.backgroundColor = "#191919";
    }
    var id = to.query.tradeId;
    var ddtoken = to.query.ddtoken;
    var userId = to.query.userId;
    var changeType = to.query.changeType;
    var ownerId = to.query.ownerId;
    var ownerType = to.query.ownerType || "";
    var circleId = to.query.circleId || "";
    if (id && ddtoken && userId && changeType) {
      var params = {
        userId: userId,
        detailId: id,
        ddtoken: decodeURIComponent(ddtoken),
        changeType: changeType
      };
      if (ownerType) {
        params.ownerType = ownerType;
        params.ownerId = ownerId;
      }
      if (ownerType == "3") {
        document.title = transObj.$t('余额明细');
      } else {
        document.title = transObj.$t('零钱明细');
      }

      if (circleId) {
        params.circleId = circleId;
      }

      http.
      get("/pay/v1/change/detail", {
        headers: {
          'Accept-Language': lang
        },
        params: params
      }).
      then((res) => {
        if (res.data.status != 1) return;

        next((vm) => {
          vm.changeDetail = res.data.data.changeDetail;
          vm.tradeDetail = res.data.data.tradeDetail;
          vm.loading = 0;
          vm.userId = userId;
          vm.ddtoken = ddtoken;
          vm.circleId = circleId;
          vm.skinModel = skinModel;
        });
      });
    }
  },
  methods: {}
};
</script>

<style lang="less" scoped>
@import "~assets/lib/mixin";

.pocket-detail-wrap {
  .pocket-amount {
    padding: 29px 15px 25px;
    .flex();
    .justify-content(space-between);
    .setLine("bottom", @lineColor);
    color: #000000;

    .desc {
      font-size: 15px;
    }

    .amount {
      margin-top: -5px;
      font-size: 30px;
      font-weight: 600;
    }
  }

  .pocket-desc {
    padding: 20px 0;
    font-size: 15px;
    .setLine("bottom", @lineColor);

    .desc-item {
      padding: 5px 15px;
      .flex();
      .justify-content(space-between);

      .label {
        color: #888888;
        margin-right: 15px;
      }

      .desc {
        color: #000000;
      }
    }
  }
}

.trade-base-info-tixian {
  padding: 30px 0 48px;
  margin: 0 30px;
  border-bottom: 0.5px solid #E5E5E5;

  .trade-object-image {
    width: 54px;
    height: 54px;
    object-fit: contain;
    border-radius: 50%;
    margin: 0 auto;
    display: block;
  }

  p {
    text-align: center;
  }

  .trade-ways {
    margin-top: 20px;
    line-height: 17px;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #1A1A1A;
  }

  .trade-money {
    margin-top: 18px;
    line-height: 30px;
    font-weight: 600;
    font-family: PingFangSC-Semibold;
    font-size: 30px;
    color: #000000;
  }
}

.trade-detail-info {
  padding: 23px 30px 20px;

  .detail-item {
    .flex();
    .justify-content(space-between);
    line-height: 30px;

    span {
      font-family: PingFangSC-Regular;
      font-size: 15px;
    }

    .detail-sub-title {
      color: #888888;
      min-width: 60px;
      margin-right: 15px;
      display: flex;
      align-items: center;

      .settleRatio,
      .currTaxAmount {
        display: inline-block;
        width: 16px;
        height: 16px;
        background: url("~assets/settleRatio.png") center no-repeat;
        background-size: contain;
        margin-left: 5px;
      }
    }

    .detail-sub-content {
      color: #000;

      &.red-envelope {
        color: #007aff;

        &:active {
          color: #005abc;
        }
      }

      .goods-name {
        max-width: 200px;
        .one-line;
      }
    }
  }
}

.pocket-wrap-dark {
  .pocket-amount {
    color: #d1d1d1;
    .setLine("bottom", #242424);
  }

  .pocket-desc {
    .setLine("bottom", #242424);

    .desc-item {
      .label {
        color: #8b8b8b;
      }

      .desc {
        color: #d1d1d1;
      }
    }
  }

  .trade-base-info-tixian {
    border-bottom: 0.5px solid #242424;

    .trade-ways {
      color: #d1d1d1;
    }

    .trade-money {
      color: #d1d1d1;
    }
  }

  .trade-detail-info {
    .detail-item {
      .detail-sub-title {
        color: #8b8b8b;
      }

      .detail-sub-content {
        color: #d1d1d1;

        &.red-envelope {
          color: #007aff;

          &:active {
            color: #005abc;
          }
        }
      }
    }
  }
}


.spinner-wrap {
  .snake-wrap {
    width: 28px;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/pocket/detail.vue